/**
 * 常量配置
 */

// API 基础 URL - 根据环境自动选择
export const API_BASE_URL = 
  process.env.REACT_APP_API_URL || 
  'https://api.chatutil.top';

// 本地存储的 key
export const STORAGE_KEYS = {
  TOKEN: 'auth_token',
  USER: 'user_info',
} as const;

// 图片类型选项
export const IMAGE_TYPE_OPTIONS = [
  { label: '默认', value: 'default' },
  { label: '男性', value: 'male' },
  { label: '女性', value: 'female' },
  { label: '其他', value: 'other' },
] as const;

// 角色权限映射
export const ROLE_PERMISSIONS = {
  admin: ['read', 'create', 'update', 'delete'],
  editor: ['read', 'create', 'update'],
  viewer: ['read'],
} as const;

// 分类选项（可以后续从 API 获取）
export const CATEGORY_OPTIONS = [
  '风景',
  '人物',
  '动物',
  '建筑',
  '艺术',
  '科技',
  '其他',
] as const;

